import React from "react";

export const STATUS_META = {
  new: { label: "New", color: "#F5C518", bg: "rgba(245,197,24,0.12)", border: "rgba(245,197,24,0.3)" },
  contacted: { label: "Contacted", color: "#60A5FA", bg: "rgba(96,165,250,0.12)", border: "rgba(96,165,250,0.3)" },
  nurture: { label: "Nurture", color: "#FB923C", bg: "rgba(251,146,60,0.12)", border: "rgba(251,146,60,0.3)" },

  converted: { label: "Converted", color: "#34D399", bg: "rgba(52,211,153,0.12)", border: "rgba(52,211,153,0.3)" },
  lost: { label: "Lost", color: "#F87171", bg: "rgba(248,113,113,0.12)", border: "rgba(248,113,113,0.3)" },
};

export const FLAG_LABELS = {
  needs_survey: "Needs site survey",
  needs_upgrade: "Needs upgrade",
};

export const CHARGER_LABELS = {
  "bg-sync": "BG Sync EV",
  "zappi-glo": "MyEnergi Zappi GLO",
  "zappi": "MyEnergi Zappi V2.1",
  "unsure": "Not sure yet",
};

export const CHARGER_VALUES = { "bg-sync": 1295, "zappi-glo": 1495, "zappi": 1695, "unsure": 1295 };

export function formatValue(value) {
  if (value == null) return "—";
  return "€" + value.toLocaleString("en-IE");
}

export function StatusBadge({ status }) {
  const meta = STATUS_META[status] || STATUS_META.new;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap"
      style={{ color: meta.color, backgroundColor: meta.bg, border: `1px solid ${meta.border}` }}
      data-testid={`status-badge-${status}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: meta.color }} />
      {meta.label}
    </span>
  );
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IE", { day: "numeric", month: "short", year: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IE", { day: "numeric", month: "short", year: "numeric" }) +
    " at " + d.toLocaleTimeString("en-IE", { hour: "2-digit", minute: "2-digit" });
}

// Normalise an Irish phone number to international format for wa.me links
export function phoneToWhatsApp(phone) {
  const digits = (phone || "").replace(/\D/g, "");
  if (!digits) return null;
  if (digits.startsWith("353")) return digits;
  if (digits.startsWith("0")) return "353" + digits.slice(1);
  return digits;
}
